import type { CSSProperties, PropsWithChildren } from 'react';

import { cn } from '@/utils';
import { resolveSectionPaddingStyle } from '@/utils/section-padding';

type SectionPaddingContainerProps = PropsWithChildren<{
  sectionType: string;
  sectionStyle?: Record<string, unknown>;
  className?: string;
  style?: CSSProperties;
}>;

export const SectionPaddingContainer = ({
  sectionType,
  sectionStyle,
  className,
  style,
  children,
}: SectionPaddingContainerProps) => {
  const paddingStyle = resolveSectionPaddingStyle(sectionType, sectionStyle);

  return (
    <div className={cn('container mx-auto', className)} style={{ ...paddingStyle, ...style }}>
      {children}
    </div>
  );
};
